import React from "react";
import { Text } from "web/react/emo/text";
import * as styles from "./counter.css";

interface CounterProps {
    number?: number;
    iconCounterVariant: keyof typeof styles.counterIcon;
}

export function Counter({ number, iconCounterVariant }: CounterProps): JSX.Element {
    return (
        <div className={styles.counterIcon[iconCounterVariant]}>
            <Text textStyle={"footnote"} className={styles.counterText}>
                {number}
            </Text>
        </div>
    );
}
